var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { OTsRepository } from '../../infrastructure/repositories/ots.impl.repository';
import { validateFormData } from '../../utils/forms/validateForm';
import { log } from '../../utils/logger';
import { ServiceFormFillingService } from './ServiceFormFilling.impl.service';
export class OTsService {
    constructor() {
        this.repository = new OTsRepository();
        this.sffService = new ServiceFormFillingService();
    }
    getValidatedForm(serviceId, companyData, formType) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { formJson, version } = yield this.repository.getFormJson(serviceId);
                const { isValid, errors } = validateFormData(formType, formJson);
                if (!isValid) {
                    log.error('El json del formulario de OTs no es correcto', errors);
                }
                var { id } = yield this.sffService.getServiceFormFilling(companyData.companyId, serviceId);
                const generatedActivos = yield this.repository.getGeneratedActivos(id);
                return {
                    form: formJson,
                    isValid,
                    version,
                    generatedActivos,
                };
            }
            catch (error) {
                log.error('Error en getValidatedForm:', error);
                return {
                    form: null,
                    isValid: false,
                    version: '',
                    generatedActivos: [],
                };
            }
        });
    }
    getOTs(serviceFormFillingId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const otList = yield this.repository.getOTs(serviceFormFillingId);
                return otList;
            }
            catch (error) {
                log.error('Error en en traer las OTs:', error);
                return null;
            }
        });
    }
    publishOt(companyId, otId, otBody) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { id: serviceFormFillingId } = yield this.sffService.getServiceFormFilling(companyId, 1);
                log.info(`Añadiendo ots al backend para el service form filling ${serviceFormFillingId} - ot ${otId}`, { otBody });
                yield this.repository.putOt(serviceFormFillingId, otId, otBody);
                log.info('Ots añadidas');
            }
            catch (error) {
                log.error('Error añadiendo Ots (publishOt):', error);
            }
        });
    }
}
